<template>
    <Layout header-class="header-left-align" nav-alignment="left">
			<div class="top-page"
					 :style="{'background-image': `url(${require(`@/assets/images/member-banner.png`)})`}">
				<h2 class="banner-title">链上共生 安全同行</h2>
				<p class="banner-info" style="margin-top: 20px;"> 秉持“开源、韧性、包容”的初心，携手“共研、共建、共防”的伙伴，缔造自由而坚固的Web3生态基石。</p>
			</div>

			<section class="org">
				<h2 class="title center70">入会流程</h2>
				<div class="center70">
					<img src="@/assets/images/process.jpg">
				</div>
			</section>

			<section class="interest-container">
				<div class="center70">
					<h2 class="title">会员权益</h2>
				</div>
				<div class="center70">
					<div class="r-list">
						<div class="r-item">
							<div class="r-img">
								<img src="@/assets/images/r1.png">
							</div>
							<div class="r-info">
								<div class="r-title"> 情报特权 </div>
								<div class="r-content">
									访问实时暗网数据监控仪表盘，提前预警钓鱼域名生成
								</div>
							</div>
						</div>
						<div class="r-item">
							<div class="r-img">
								<img src="@/assets/images/r2.png">
							</div>
							<div class="r-info">
								<div class="r-title"> 活动优先 </div>
								<div class="r-content">
									免费参加年度Web3安全峰会，获CTO闭门晚宴邀请函
								</div>
							</div>
						</div>
						<div class="r-item">
							<div class="r-img">
								<img src="@/assets/images/r3.png">
							</div>
							<div class="r-info">
								<div class="r-title"> 技术支援 </div>
								<div class="r-content">
									每年3次免费智能合约审计服务或其他技术支援
								</div>
							</div>
						</div>
						<div class="r-item">
							<div class="r-img">
								<img src="@/assets/images/r4.png">
							</div>
							<div class="r-info">
								<div class="r-title"> 品牌露出 </div>
								<div class="r-content">
									会员单位Logo展示在协会所有白皮书、会议背景板
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section class="interest-container container2">
				<div class="center70">
					<h2 class="title">申请条件</h2>
				</div>
				<div class="center70">
					<div class="r-list">
						<div class="r-item">
							<div class="r-img">
								<img src="@/assets/images/a1.png">
							</div>
							<div class="r-info">
								<div class="r-title"> 企业会员 </div>
								<div class="r-content">
									需运营Web3相关业务满2年，TVL/用户量达到行业前30%，设立专职安全团队
								</div>
							</div>
						</div>
						<div class="r-item">
							<div class="r-img">
								<img src="@/assets/images/a2.png">
							</div>
							<div class="r-info">
								<div class="r-title"> 个人专家 </div>
								<div class="r-content">
									需提交至少3份CVE漏洞披露记录或IEEE区块链安全论文
								</div>
							</div>
						</div>
						<div class="r-item">
							<div class="r-img">
								<img src="@/assets/images/a3.png">
							</div>
							<div class="r-info">
								<div class="r-title"> 观察员 </div>
								<div class="r-content">
									新兴项目可申请6个月观察期，需每月提交安全进展报告
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

    </Layout>
</template>

<script>
    import Layout from '../components/common/Layout'
    import SectionTitle from '../components/elements/sectionTitle/SectionTitle'
    import Icon from "@/components/icon/Icon.vue";
		import countTo from 'vue-count-to'

    export default {
        name: 'About',
        components: {Icon, SectionTitle, Layout, countTo},
        data() {
            return {
						}
        }
    }
</script>
<style scoped lang="scss">
section.org {
	margin: 80px 0 40px;
	h2.title {
		font-weight: 700;
		position: relative;
		font-size: 28px;
		padding-bottom: 10px;
		margin-bottom: 20px;
	}
}
section.interest-container {
	background-color: #f4f4f4;
	&.container2 {
		background-color: #ffffff;
	}
	padding: 80px 0;
	h2.title {
		font-weight: 700;
		position: relative;
		font-size: 28px;
		padding-bottom: 10px;
		margin-bottom: 20px;
	}
	.r-list {
		margin-top: 80px;
		display: flex;
		.r-item {
			padding: 0 40px;
			width: 25%;
			display: flex;
			flex-direction: column;
			gap: 40px;
			.r-img {
				text-align: center;
				img {
					width: 100px;
					height: 100px;
				}
			}
			.r-info {
				.r-title {
					color: #000000;
					font-size: 24px;
					font-weight: 700;
					text-align: center;
					margin-bottom: 20px;
				}
				.r-content {
					font-size: 14px;
					color: grey;
					line-height: 1.5;
					text-align: justify;
				}
			}
		}
	}
	&.container2 {
		.r-list {
			.r-item {
				width: 33%;
			}
		}
	}
}
@media screen and (max-width: 850px) {
	section.org {
		margin-top: 40px;
		margin-bottom: 40px;
		h2.title {
			font-size: 28px;
			margin-bottom: 0;
			&:after {
				width: 110px;
			}
		}
		.org-img {
			margin-top: 20px;
		}
	}
	section.interest-container {
		padding: 40px 0;
		.r-list {
			margin-top: 40px;
			flex-direction: column;
			gap: 40px;
			.r-item {
				width: 100%;
				gap: 20px;
			}
		}
		&.container2 {
			.r-list {
				margin-top: 40px;
				flex-direction: column;
				gap: 40px;
				.r-item {
					width: 100%;
					gap: 20px;
				}
			}
		}
	}
}
</style>
